export enum DateFilterOptionType {
  Last7Days = 'last7days',
  Last30Days = 'last30days',
  Last90Days = 'last90Days',
}
